import Vue from 'vue';
import './plugins/axios';
import VueRouter from "vue-router";
import './plugins/element.js'
import './plugins/bdo-web.js';
import router from "./pc/router";
import appConfig, {
  writeToCache,
  // readFromCache,
} from './pc/app.config.js';
// import App from './App.vue'
import "./style/index.css"
import "./style/global.scss"
import http from 'axios';
import {i18nServer, onlineServiceOn,} from './config.js';
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

import i18n from './i18n'

Vue.use(VueRouter);


import confirmjs from './pc/confirm.js'

Vue.prototype.$confirm = confirmjs;
window.$confirm = confirmjs;
/**
 * 加载国际化词条文件
 * @param  {[type]} langCode [description]
 * @return {[type]}          [description]
 */
export const loadI18NData = (langCode) => {
  const langCodeObj = {
    'zh_CN': 'zh_CN',
    'zh_HK': 'zh_HK',
    'en': 'en_US',
  };

  if(process.env.NODE_ENV === 'production'){
    return http.get(`/signup/js/locales/${ langCode }.json`)
  }

  return http.get(`${ onlineServiceOn ? i18nServer : '' }/i18n/dist/${ langCodeObj[langCode] }.json`, {
    // timeout: 3000
  })
    .catch(err => {
      console.log('在线词条加载失败, 开始加载本地词条', err);

      return http
        .get(`/js/locales/${ langCode }.json`)
    })
}

// 加载在线词条;
loadI18NData('en').then(res => {
  i18n.setLocaleMessage('en', res.data);
});

Vue.config.productionTip = false
appConfig(Vue);


// 如果用户重新进入app 需要先清除本地缓存
// 为了方便调试, 在其它页面刷新不需要清除
if (['#/index', '#/check-mid-process'].indexOf(window.location.hash) !== -1) {
  // 清空历史缓存
  // eslint-disable-next-line
  console.log('清空历史缓存')
  window.localStorage.clear();
}

window.loadI18NData = (langCode, callback) => {
  loadI18NData(langCode).then(res => {
    writeToCache('langCode', langCode);
    i18n.setLocaleMessage(langCode, res.data);
    i18n.locale = langCode;
    callback && callback(res.data);
  });
};

process.env.NODE_ENV !== 'development' && Sentry.init({
  Vue,
  dsn: "https://e7d33ef113fa437da04cb4da396b671d@sentry.swiftpass.cn/105",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "my-site-url.com", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

new Vue({
  router: router,
  i18n,
  render: h => h("router-view")
}).$mount('#app')


